import { apiUrl, authHeaders } from './auth';

export const campaignGoal = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/setGoal';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const campaignStory = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/setStory';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const campaignVideoUrl = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/campaign/setVideoUrl';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};
